import {maxBy} from "lodash";
import writeXlsxFile from "write-excel-file";
import {saveAs} from 'file-saver';

function isValidHttpUrl(string) {
    let url;
    try {
        url = new URL(string);
    } catch (_) {
        return false;
    }
    return url.protocol === "http:" || url.protocol === "https:";
}

const downloadExcel = (_headers, rows, imageColumn, filename, onlyChanged) => {
    let headers = [..._headers]
    const maxImages = maxBy(rows, it => it.images.length).images.length
    for (let i = 0; i < maxImages; ++i) {
        headers.push(imageColumn)
    }
    console.log('Only changed', onlyChanged)
    console.log('Max images', maxImages)

    headers = headers.map(it => ({value: it, fontWeight: 'bold'}))
    if (onlyChanged) {
        rows = rows.filter(it => it.changed)
    }
    rows = rows.map(row => {
        const cells = [...row.cells]
        cells.push(...row.images)
        console.log(row.cells.length, row.images.length)
        return cells.map(it => ({value: it}))
    })
    console.log(rows[0])
    const data = [headers, ...rows]
    writeXlsxFile(data, {fileName: filename, sheet: 'Default sheet'}).then(file => saveAs(file, filename))
}

export {isValidHttpUrl, downloadExcel}
